module.exports = __webpack_public_path__ + "static/img/salesHome_difficulties_2.54c1e40.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/salesHome_difficulties_2.svg
// module id = 7+Ll
// module chunks = 1